import React from 'react';

import { CreateExtractTasksMode } from '~src/extract/actions/CreateExtractTaskAction';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { IDataSourceDetailInfo } from '../../datasource/models/IDataSourceInfo';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { IRefreshExtractAction } from '../../ts/ServerApi/types/actionNames';
import { DisplayMode } from '../../ts/ServerApi/types/ISessionInfo';
import { createExtractRefresh } from '../actions/spaces/CreateExtractRefreshAction';
import { createRemoteExtractRefresh } from '../actions/spaces/CreateRemoteExtractRefreshAction';
import { getAppStore } from '../AppStore';
import { SubspaceName } from '../state/SpaceInfo';
import { currentUserIsOwnerOrAdmin } from '../utils/MixedContentHelpers';
import { ExplorerEmptyStateProps } from './Components/ExplorerEmpyState';
import { ConnectedExplorer } from './Explorer/ConnectedExplorer';
import { ConnectedCreateContentButton } from './Explorer/CreateContent/ConnectedCreateContentButton';
import { CreateContentButtonOwnProps } from './Explorer/CreateContent/CreateContentButton';
import { NewExtractRefreshButton } from './Explorer/CreateExtractRefreshButton';
import { ExplorerToolbarVisibility } from './Explorer/Explorer';
import { ContentSpecificControls } from './Explorer/ExplorerToolbar';
import { Subspace } from './TabbedSpace';

export interface SubspaceParams {
  name: SubspaceName;
  tabLabel: string;
  supportedDisplayModes: ReadonlyArray<DisplayMode>; // TODO this should come from ExplorableItemTypeDefinition?
  shouldRenderContentCount: boolean;
  contentCount?: number;
  contentCountUpToDate?: boolean;
  toolbarContentFilterControl?: JSX.Element;
  toolbarContentSpecificControls?: ContentSpecificControls;
  supportFilterPanel?: boolean;
  hideSelection?: boolean;
  hideSelectionAndActionMenu?: boolean;
  toolbarVisibility: ExplorerToolbarVisibility;
  emptyStateProps?: ExplorerEmptyStateProps;
}

export function explorerSubspace(params: SubspaceParams): Subspace {
  return {
    name: params.name,
    tabLabel: params.tabLabel,
    tabContentCount: params.contentCount,
    shouldRenderTabContentCount: params.shouldRenderContentCount,
    tabContentCountUpToDate: params.contentCountUpToDate,
    renderContent: () =>
      <ConnectedExplorer
        supportedDisplayModes={params.supportedDisplayModes}
        hideSelectionAndActionMenu={ params.hideSelectionAndActionMenu}
        toolbarProps= {{
          supportFilterPanel: params.supportFilterPanel,
          hideSelection:params.hideSelection,
          toolbarContentSpecificControls: params.toolbarContentSpecificControls,
          toolbarVisibility: params.toolbarVisibility,
          toolbarContentFilterControl: params.toolbarContentFilterControl,
        }}
        emptyStateProps={params.emptyStateProps}
      />
  };
}

export function newExtractRefreshButton(
  content: IContentInfo,
  actions: IRefreshExtractAction,
  disabled?: boolean
): JSX.Element {
  const appState = getAppStore().getState();

  if (currentUserIsOwnerOrAdmin(appState, content) || actions.refreshExtract) {
    const taskMode = getSessionManagementServiceInstance().isOnlineEnvironment() ?
      CreateExtractTasksMode.AllowScheduleOnServerAndClient : CreateExtractTasksMode.AllowScheduleOnServer;
    const action = createExtractRefresh([content], taskMode);
    return <NewExtractRefreshButton handleClick={() => getAppStore().dispatch(action)}
      disabled={disabled}/>;
  }

  return null;
}

export function newRemoteExtractRefreshButton(
  datasource: IDataSourceDetailInfo
): JSX.Element {
  const appState = getAppStore().getState();

  if (currentUserIsOwnerOrAdmin(appState, datasource)) {
    const action = createRemoteExtractRefresh(datasource);
    return <NewExtractRefreshButton handleClick={() => getAppStore().dispatch(action)}/>;
  }

  return null;
}

export function createContentButton(ownProps?: CreateContentButtonOwnProps): JSX.Element {
  return <ConnectedCreateContentButton {...ownProps} />;
}
